import { MikroBus } from '@mgdis/mikrobus';
import { parseEvent } from '@mgdis/mikrobus-contract';
class EventsService {
    #appName;
    PORTAIL_DEPOT_DEMANDE_AIDES;
    constructor({ tenantId }) {
        this.#appName = 'portail-depot-demandes';
        this.PORTAIL_DEPOT_DEMANDE_AIDES = new EventSubscriber(this.#appName, this.#appName, tenantId);
    }
}
class EventSubscriber extends EventTarget {
    #bus;
    constructor(channelName, appName, tenantId) {
        super();
        this.#bus = new MikroBus({
            channel: channelName,
            appId: appName,
            parseEvent,
            tenant: tenantId,
        });
        // eslint-disable-next-line unicorn/prefer-add-event-listener
        this.#bus.onmessage = this.#onmessage.bind(this);
    }
    /**
     * Send a native event on message reception
     * @param event - Mikrobus event
     */
    #onmessage(event) {
        this.dispatchEvent(new CustomEvent(event.data.type, { detail: event.data.payload }));
    }
    /**
     * Sends a message on the channel of the given type and given payload
     * @param type - Event name
     * @param payload - Event data
     */
    emitMessage(type, payload) {
        this.#bus.postMessage({
            type,
            payload,
        });
    }
}
export { EventsService };
//# sourceMappingURL=events-service.js.map